import DashboardTypes from '../types/DashboardTypes';

const initialState = { isLoading: false, dashItem: [], filterData: {} };

// eslint-disable-next-line default-param-last
const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case DashboardTypes.GET_DASHBOARD_ALL_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DashboardTypes.GET_DASHBOARD_ALL_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dashItem: action.payload
      };
    case DashboardTypes.GET_DASHBOARD_ALL_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        dashItem: []
      };

    case DashboardTypes.GET_FILTER_OPTIONS_REQUEST:
      return {
        ...state,
        isLoading: false
      };
    case DashboardTypes.GET_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        filterData: action.payload
      };
    case DashboardTypes.GET_FILTER_OPTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
        filterData: {}
      };

    default:
      return state;
  }
};
export default dashboard;
